import { StrictMode, Suspense } from 'react';
import { render } from 'react-dom';
import 'general/i18react';
import Loader from 'components/loader/loadingIcon';
import reportWebVitals from './reportWebVitals';
import App from './App';

render(
  <StrictMode>
    <Suspense fallback={Loader}>
      <App />
    </Suspense>
  </StrictMode>,

  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
